export default __webpack_public_path__ + "92c9130c445ec5caffc77fec547b7b2d.png";